<template>
  <div>
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="80%"
      center
      top="20vh"
    >
      <el-divider></el-divider>
      <div class="centers">
        <div class="dia_ones">
          <div>
            <span>产品信息：</span>
            <el-input v-model="row.productname" disabled placeholder="春节3小时双板滑雪票+基础雪具"></el-input>
          </div>
          <div>
            <span>订单号：</span>
            <el-input v-model="row.ordernumber" disabled placeholder=""></el-input>
          </div>
          <div>
            <span>消费码：</span>
            <el-input disabled v-model="row.ordercode" ></el-input>
          </div>
          <div>
            <span>第三方订单号：</span>
            <el-input disabled v-model="row.OnlyCode"></el-input>
          </div>
        </div>
        <div class="dia_two">
          <div>
            <span>分销商：</span>
            <el-input disabled v-model="row.distributor_name"></el-input>
          </div>
          <div>
            <span>游客信息：</span>
            <el-input disabled v-model="row.username"></el-input>
          </div>
          <div>
            <span>核销时间：</span>
            <el-input disabled v-model="row.UseTime"></el-input>
          </div>
          <div class="dia_two_btns" @click="exportdefa">
            导出流水
          </div>
        </div>
        <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            v-loading="loading"
            style="width: 100%">
              <el-table-column prop="createtime" label="交易时间"></el-table-column>
              <el-table-column prop="wx_number" label="交易流水号"></el-table-column>
              <el-table-column prop="deal_state" label="交易状态">
                <template slot-scope="scope">
                  <span :class="scope.row.deal_state=='退款成功'?'activess':''">{{scope.row.deal_state}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="交易金额"></el-table-column>
              <el-table-column prop="deal_type" label="交易类型"></el-table-column>
              <!-- <el-table-column prop="channelName" label="交易数量"></el-table-column> -->
              <!-- <el-table-column prop="channelName" label="账户余额"></el-table-column> -->
        </el-table>
        <!-- <div class="pagination">
            <span class="demonstration">共{{data.total}}条记录，</span>
            <span class="demonstration">当前显示第{{data.page}}页</span>
            <el-pagination background layout="prev, pager, next" :total="data.total" :page-size="data.page_size" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { xcxOrderDetail , xcxOrderDetailExport } from '@/request/scenic.js'
export default {
  data(){
    return{
      addProDialogVisible:false,
      titleType:'订单详情123',
      tableData:[{}],
      data:{
        token:window.sessionStorage.getItem('Token'),
        total:0,
        page:1,
        page_size:10,
        deposit_id:'',
        ordertype:'',
        ordercode:'',
        newcode:'',
        card_number:''
      },
      row:'',
      loading:true
    }
  },
  methods:{
    addProHandleClose(){
      this.addProDialogVisible = false
      this.$emit('addProClose')
    },
    exportdefa(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        deposit_id:this.row.deposit_id,
        ordertype:this.row.ordertype,
        ordercode:this.row.ordercode,
        newcode:this.row.newcode,
        card_number:''
      }
      const loading = this.$loading({
          lock: true,
          text: '报表下载中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      xcxOrderDetailExport(data).then(res=>{
          if(res.data.status=='ok'){
              loading.close();
              window.location.href = res.data.result
          }else{
            loading.close();
            this.$message.error(res.data.msg)
          }
      })
    },
    addProFn(row){
      this.row = row
      this.data = {
        token:window.sessionStorage.getItem('Token'),
        total:0,
        page:1,
        page_size:10,
        deposit_id:row.deposit_id,
        ordertype:row.ordertype,
        ordercode:row.ordercode,
        newcode:row.newcode,
        card_number:''
      }
      xcxOrderDetail(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.loading = false
          this.tableData = res.data.result
        }
      })
      this.addProDialogVisible = true
    },
      // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
  }
}
</script>
<style lang="less" scoped>
.centers{
  padding: 0 2rem;
  box-sizing: border-box;
  .dia_ones{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    >div{
      margin: 0 0 2rem 0 ;
      display: flex;
      align-items: center;
      &:nth-child(n+2){
        margin-left: 2rem;
      }
      >span{
        color: #666666;
        font-size: 1.4rem;
      }
      ::v-deep .el-input{
        width: 20rem; 
      }
      &:nth-child(1){
        ::v-deep .el-input{
          width: 50rem;
        }
      }
    }
  }
  .dia_two{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    >div{
      margin: 0 0 2rem 0 ;
      display: flex;
      align-items: center;
      >span{
        display: block;
        color: #666666;
        font-size: 1.4rem;
      }
      &:nth-child(1){
        span{
          margin-left: 1.2rem;
        }
        ::v-deep .el-input{
          width: 20rem;
        }
      }
      &:nth-child(2){
        ::v-deep .el-input{
          width: 47.1rem;
        }
        >span{
          display: block;
          margin-left: 2rem;
        }
      }
      &:nth-child(3){
        ::v-deep .el-input{
          width: 20rem;
        }
        >span{
          display: block;
          margin-left: 2rem;
        }
      }
    }
    .dia_two_btns{
      width: 12rem;
      height: 4rem;
      border-radius: 0.4rem;
      border: 1px solid #246DEB;
      color: #246DEB;
      font-size: 1.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 2rem;
      cursor: pointer;
    }
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.activess{
  color: #FF4D4F;
}
</style>